import React from "react";
import {Box} from "@mui/material";
import {IconAreaTable, IconChipMultiplePerson} from "../../../../components/buttons/IconButtons";
import SelectedUserEmailPhoneCard from "../../../../components/CustomAvailableAssignedItems/SubComponents/SelectedUserEmailPhoneCard";
import {TABLES} from "../../../../Apis/Tables";
import ZoneItemCard from "./ZoneItemCard";
import ZoneAccessAssignedSection from "./ZoneAccessAssignedSection";

/**
 * Zones and guards of an expanded zone access, each one as a read-only assigned items section.
 */
const ZoneAccessExpandedRow = ({zoneAccess}) => (
    <Box className={"shift-detail-lists"}>
        <ZoneAccessAssignedSection
            zoneAccessId={zoneAccess?.id}
            model={TABLES.ZONE_ACCESS_ASSIGNED_ZONE}
            keyId={'id'}
            title={'assigned_zones'}
            Icon={IconAreaTable}
            labelRowsPerPage={'zone_per_page'}
            searchTitle={'search_by_name'}
            tableNotInformationLegend={'nothing_selected_yet'}
            renderAssignedItem={({item}) => <ZoneItemCard item={item}/>}
        />
        <div className={"mb-3"}/>
        <ZoneAccessAssignedSection
            zoneAccessId={zoneAccess?.id}
            model={TABLES.ZONE_ACCESS_ASSIGNED_GUARD}
            keyId={'userId'}
            title={'assigned_guards'}
            Icon={IconChipMultiplePerson}
            labelRowsPerPage={'guards_per_page'}
            searchTitle={'search_by_name_email_or_phone'}
            tableNotInformationLegend={'no_guards_assigned'}
            renderAssignedItem={({item, keyId}) => (
                <SelectedUserEmailPhoneCard keyId={keyId} item={{...item, disabled: false}}/>
            )}
        />
    </Box>
);

export default ZoneAccessExpandedRow;
